import React, { useCallback, useEffect, useState } from 'react';
import * as cls from './core-engine.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';
import { CarouselHalf } from '../../../../ui/components/carousel-half';

const items = [
  {
    ico: `${IMG_PATH}/our-technology/energy-intelligence/ico-learning-detection.svg`,
    title: 'Early detection',
    text: 'The system starts identifying major appliance behaviours immediately and improves over the first weeks.',
  },
  {
    ico: `${IMG_PATH}/our-technology/energy-intelligence/ico-continuous-learning.svg`,
    title: 'Continuous improvement',
    text: 'models refine accuracy over time as more patterns are observed (and optional feedback is provided).',
  },
  {
    ico: `${IMG_PATH}/our-technology/energy-intelligence/ico-no-manual-tagging.svg`,
    title: 'No manual tagging required',
    text: 'appliance events are detected automatically; optional confirmation can improve precision.',
  },
  {
    ico: `${IMG_PATH}/our-technology/energy-intelligence/ico-feedback-loop.svg`,
    title: 'Feedback loop',
    text: 'lightweight in-app feedback improves results for the household and helps strengthen performance across the fleet (where applicable).',
  },
];

export const CoreEngine = () => {
  const [perPage, setPerPage] = useState(4);

  const checkWidth = useCallback(() => {
    const width = window.innerWidth;
    if (width <= 600) {
      setPerPage(1);
    } else if (width <= 767) {
      setPerPage(2);
    } else if (width <= 999) {
      setPerPage(3);
    } else {
      setPerPage(4);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', checkWidth);
    checkWidth();
    return () => window.removeEventListener('resize', checkWidth);
  }, [checkWidth]);

  return (
    <Section backgroundContrast classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        Core Engine Explained Simply
      </Typography>

      <Typography>
        Voltaware analyses a home’s overall electricity signal. Each device
        leaves a unique <b>electrical fingerprint</b> when it turns on, off, or
        changes state. Our ML models translate these patterns into
        appliance-level usage and events, delivered via the app or through APIs.
      </Typography>

      <div className={cls.imgWrapper}>
        <img
          alt="Diagram “Home electricity usage → fingerprints → appliances → insights.”"
          src={`${IMG_PATH}/our-technology/energy-intelligence/core-engine-explained-simply.png`}
        />
        <img
          alt="Diagram “Home electricity usage → fingerprints → appliances → insights.”"
          src={`${IMG_PATH}/our-technology/energy-intelligence/core-engine-explained-simply-mobile.png`}
        />
      </div>

      <CarouselHalf
        className={cls.carousel}
        defaultPerPage={false}
        perPage={perPage}
      >
        {items.map((item, index) => (
          <div className={cls.item} key={index}>
            <div className={cls.item__title}>
              <img src={item.ico} alt="" />
              <Typography as="p" tag="h3">
                {item.title}
              </Typography>
            </div>
            <Typography>{item.text}</Typography>
          </div>
        ))}
      </CarouselHalf>
    </Section>
  );
};
